<template>
  <div class="sidebar">
    <div v-if="$store.state.loggedIn && !isProjectApplication" class="actualSidebar">
      <div class="sidebarButton" v-if="getIsViewer">
        <a href="#" @click.prevent="goToOverview"><i class="bi bi-collection sidebarIcons"></i>Übersicht</a>
      </div>

      <div class="sidebarButton" v-if="getProjectId">
        <router-link to="dashboard"><i class="bi bi-clipboard-data sidebarIcons"></i>{{ $t(localeConsts.sidebarDashboard) }}</router-link>
      </div>

      <template v-if="!getIsViewer && getProjectId">
        <div class="sidebarButton">
          <router-link to="workReports"><i class="bi bi-clock sidebarIcons"></i>{{ $t(localeConsts.sidebarWorkReports) }}</router-link>
        </div>

        <div class="sidebarDropdown" @mouseover="statusReportsDropdown = true">
          <i class="bi bi-journal-check sidebarIcons"></i>{{ $t(localeConsts.sidebarStatusReports) }}
        </div>

        <div v-if="statusReportsDropdown" class="sidebarDropdownContainer" @mouseleave="statusReportsDropdown = false">
          <ul>
            <li>
              <div class="sidebarDropdownElement">
                <router-link to="statusReports"> {{ $t(localeConsts.sidebarViewStatusReports) }}</router-link>
              </div>
            </li>

            <li v-if="!getIsSupervisor">
              <div class="sidebarDropdownElement">
                <router-link to="createEditStatusReport">{{ $t(localeConsts.sidebarCreateEditStatusReports) }}</router-link>
              </div>
            </li>
          </ul>
        </div>

        <div v-if="hasActivePeerReviewRound || getIsSupervisor" class="sidebarButton">
          <a href="#" @click.prevent="navigateToPeerReview"
            ><i class="bi bi-people-fill sidebarIcons"></i>{{ $t(localeConsts.sidebarPeerReview) }}</a
          >
        </div>

        <div class="sidebarDropdown" @mouseover="rolesDropdown = true">
          <i class="bi bi-card-heading sidebarIcons"></i>{{ $t(localeConsts.sidebarRoles) }}
        </div>

        <div v-if="rolesDropdown" class="sidebarDropdownContainer" @mouseleave="rolesDropdown = false">
          <ul>
            <li>
              <div class="sidebarDropdownElement">
                <router-link to="roles"> {{ $t(localeConsts.sidebarViewRoles) }}</router-link>
              </div>
            </li>

            <li v-if="!getIsSupervisor">
              <div class="sidebarDropdownElement">
                <router-link to="editRoles"> {{ $t(localeConsts.sidebarEditRoles) }}</router-link>
              </div>
            </li>
          </ul>
        </div>
      </template>

      <div v-if="getIsAdministrator" class="sidebarButton">
        <router-link to="evaluateApplications"
          ><i class="bi bi-file-earmark-person sidebarIcons"></i>{{ $t(localeConsts.sidebarEvaluateApplications) }}</router-link
        >
      </div>

      <div class="sidebarButton">
        <router-link to="changePassword"><i class="bi bi-key sidebarIcons"></i>{{ $t(localeConsts.sidebarChangePassword) }}</router-link>
      </div>
    </div>
    <div v-else-if="isProjectApplication"></div>
    <div v-else class="actualSidebar sidebarButton">
      <em class="bi bi-box-arrow-in-right sidebarIcons"></em>{{ $t(localeConsts.sidebarLogin) }}
    </div>
  </div>
</template>

<script>
import mapGettersMixin from '../../mixins/mapGettersMixin'
import axios from '../../../axios'

export default {
  name: 'SidebarComponent',
  mixins: [mapGettersMixin],
  data() {
    return {
      localeConsts: {
        sidebarDashboard: 'SIDEBAR.DASHBOARD',
        sidebarWorkReports: 'SIDEBAR.WORK_REPORTS',
        sidebarStatusReports: 'SIDEBAR.STATUS_REPORTS',
        sidebarViewStatusReports: 'SIDEBAR.VIEW_STATUS_REPORTS',
        sidebarCreateEditStatusReports: 'SIDEBAR.CREATE_EDIT_STATUS_REPORT',
        sidebarPeerReview: 'SIDEBAR.PEER_REVIEW',
        sidebarRoles: 'SIDEBAR.ROLES',
        sidebarViewRoles: 'SIDEBAR.VIEW_ROLES',
        sidebarEditRoles: 'SIDEBAR.EDIT_ROLES',
        sidebarEvaluateApplications: 'SIDEBAR.EVALUATE_APPLICATIONS',
        sidebarChangePassword: 'SIDEBAR.CHANGE_PASSWORD',
        sidebarLogin: 'LOGIN.LOG_IN'
      },

      statusReportsDropdown: false,
      rolesDropdown: false,
      hasActivePeerReviewRound: false
    }
  },
  computed: {
    isProjectApplication() {
      return this.currentRoute == 'ProjectApplication' //eslint-disable-line
    },
    currentRoute() {
      return this.$route.name
    },
    getIsViewer() {
      return this.$store.getters['authentication/getIsViewer']
    }
  },
  watch: {
    '$store.state.loggedIn': {
      immediate: true,
      async handler(isLoggedIn) {
        if (isLoggedIn) {
          await this.checkActivePeerReviewRound()
        } else {
          this.hasActivePeerReviewRound = false
        }
      }
    }
  },
  methods: {
    navigateToPeerReview() {
      this.$root.$emit('peer-review-reset')
      this.$router.push('/peerReview').catch((err) => {
        if (err.name !== 'NavigationDuplicated' && !err.message.includes('Avoided redundant navigation')) {
          throw err
        }
      })
    },
    async checkActivePeerReviewRound() {
      try {
        const response = await axios.get('peer-review-rounds/')
        const now = new Date()
        this.hasActivePeerReviewRound = response.data.some((round) => {
          const startDate = new Date(round.start_date)
          const endDate = new Date(round.end_date)
          return now >= startDate && now <= endDate
        })
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Error fetching peer review rounds:', error)
        this.hasActivePeerReviewRound = false
      }
    },
    goToOverview() {
      this.$store.commit('authentication/setProjectId', null)
      this.$store.commit('authentication/setProjectName', '')
      if (this.$route.name !== 'Dashboard') {
        this.$router.push('/dashboard')
      }
    }
  }
}
</script>

<style lang="scss">
$text-color: #8b69a9;
$background-color: #dfe6e1;
$hover-color: lightgrey;
$link-color: darkgrey;

.sidebar {
  background-color: $background-color;
  display: flex;
  flex-direction: column;
  width: 220px;
}

.sidebarIcons {
  font-size: 25px;
  margin-right: 15px;
  padding-bottom: 4px;
}

.sidebarButton,
.sidebarDropdown {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  color: $text-color;
  padding-top: 10px;
  padding-left: 15px;
  padding-right: 15px;
  font-weight: bold;
}

.sidebarButton a,
.sidebarDropdownElement a {
  text-decoration: none;
  color: $text-color;
}

.sidebarButton:hover,
.sidebarDropdown:hover,
.sidebarDropdownElement:hover {
  background-color: $hover-color;
}

.sidebarButton:link,
.sidebarDropdown:link {
  background-color: $link-color;
}

.sidebarDropdownContainer {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  font-size: 15px;
  padding-left: 12px;
}

.sidebarDropdownElement {
  padding-left: 0;
  margin-left: 0;
}

/*unordered list */
ul {
  list-style-type: none;
}
</style>
